// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/yuan/coder/app_project/CoreBTC-project/CoreBTC-crm/src/models/timezone';
import model_2 from '/Users/yuan/coder/app_project/CoreBTC-project/CoreBTC-crm/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'timezone', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
